export default __webpack_public_path__ + "static/sam42_marketing-5c223814f434511b2af855ec3fecb7d1.jpg";